import React from 'react';
import '../styles/global.css';

export default function AuthLayout({ children, isSingleColumn = false }) {
  return (
    <div className="auth-page">
      <div className={`auth-grid${isSingleColumn ? ' single-col' : ''}`}>
        {children}
      </div>
    </div>
  );
}
